/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserVerificationDto } from '../../models/user-verification-dto';

export interface CreateManualVerification$Params {
  userId?: number;
  'X-API-Version'?: string;
}

export function createManualVerification(http: HttpClient, rootUrl: string, params?: CreateManualVerification$Params, context?: HttpContext): Observable<StrictHttpResponse<UserVerificationDto>> {
  const rb = new RequestBuilder(rootUrl, createManualVerification.PATH, 'post');
  if (params) {
    rb.query('userId', params.userId, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserVerificationDto>;
    })
  );
}

createManualVerification.PATH = '/api/user-verifications';
